type SortableItem = {
    name?: string;
    id?: string | number | null;
    createdTimestamp?: string;
    [key: string]: any;
};

export const sortUtils = {
    byName: <T extends SortableItem>(a: T, b: T): number => {
        if (!a.name || !b.name) return 0;
        return a.name.localeCompare(b.name);
    },

    byTimestampAndId: <T extends SortableItem>(a: T, b: T): number => {
        if (a.createdTimestamp === undefined || b.createdTimestamp === undefined) {
            if (a.id === undefined || b.id === undefined) {
                return 0;
            }
            return String(a.id).localeCompare(String(b.id));
        }

        if (a.createdTimestamp === b.createdTimestamp) {
            if (a.id === undefined || b.id === undefined) {
                return 0;
            }
            return String(a.id).localeCompare(String(b.id));
        }

        return a.createdTimestamp.localeCompare(b.createdTimestamp);
    },

    byNumericField: (field: string) => <T extends Record<string, any>>(a: T, b: T): number => {
        return b[field] - a[field];
    },

    byStringField: (field: string) => <T extends Record<string, any>>(a: T, b: T): number => {
        if (!a[field] || !b[field]) return 0;
        return a[field].localeCompare(b[field]);
    }
};